(() => {
  if (window.__smartfulCardSwatchPreviewInitialized) return;
  window.__smartfulCardSwatchPreviewInitialized = true;

  const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const states = new WeakMap();
  const HOVER_DELAY = 120;
  const RESTORE_DELAY = 70;

  function getCard(swatch) {
    return swatch.closest('.card-wrapper');
  }

  function getState(card) {
    let state = states.get(card);

    if (!state) {
      const images = Array.from(card.querySelectorAll('.card__media .media > img')).map((image) => ({
        element: image,
        src: image.getAttribute('src'),
        srcset: image.getAttribute('srcset')
      }));

      state = {
        images,
        activeSwatch: null,
        hoverTimer: null,
        restoreTimer: null
      };

      states.set(card, state);
    }

    return state;
  }

  function applyPreview(card, previewSrc) {
    const state = getState(card);

    state.images.forEach(({ element }) => {
      element.removeAttribute('srcset');
      element.setAttribute('src', previewSrc);
    });
  }

  function restoreCard(card) {
    const state = states.get(card);
    if (!state) return;

    state.images.forEach(({ element, src, srcset }) => {
      if (srcset) {
        element.setAttribute('srcset', srcset);
      } else {
        element.removeAttribute('srcset');
      }

      if (src) {
        element.setAttribute('src', src);
      }
    });
  }

  function beginPreview(swatch) {
    if (!fineHover.matches) return;

    const previewSrc = swatch.dataset.smartfulPreviewSrc;
    const card = getCard(swatch);

    if (!previewSrc || !card) return;

    const state = getState(card);

    window.clearTimeout(state.hoverTimer);
    window.clearTimeout(state.restoreTimer);
    state.activeSwatch = swatch;

    let delayDone = false;
    let imageReady = false;

    const loader = new Image();

    const maybeApply = () => {
      if (
        delayDone &&
        imageReady &&
        state.activeSwatch === swatch
      ) {
        applyPreview(card, previewSrc);
      }
    };

    loader.addEventListener('load', () => {
      imageReady = true;
      maybeApply();
    }, { once: true });

    loader.src = previewSrc;

    if (loader.complete && loader.naturalWidth > 0) {
      imageReady = true;
    }

    state.hoverTimer = window.setTimeout(() => {
      delayDone = true;
      maybeApply();
    }, HOVER_DELAY);
  }

  function endPreview(swatch) {
    const card = getCard(swatch);
    if (!card) return;

    const state = states.get(card);
    if (!state || state.activeSwatch !== swatch) return;

    window.clearTimeout(state.hoverTimer);
    window.clearTimeout(state.restoreTimer);
    state.activeSwatch = null;

    state.restoreTimer = window.setTimeout(() => {
      if (state.activeSwatch === null) {
        restoreCard(card);
      }
    }, RESTORE_DELAY);
  }

  document.addEventListener('pointerover', (event) => {
    if (!fineHover.matches) return;

    const swatch = event.target.closest('.smartful-card-swatch');
    if (!swatch) return;

    if (event.relatedTarget && swatch.contains(event.relatedTarget)) return;
    beginPreview(swatch);
  });

  document.addEventListener('pointerout', (event) => {
    if (!fineHover.matches) return;

    const swatch = event.target.closest('.smartful-card-swatch');
    if (!swatch) return;

    if (event.relatedTarget && swatch.contains(event.relatedTarget)) return;
    endPreview(swatch);
  });
})();
